import type { ConstValues } from '@openx/types/helpers.ts';

export const DealParticipantsField = {
  DEAL_PARTICIPANTS: 'deal_participants',
  DSP: 'demand_partner',
  BUYER_IDS: 'buyer_ids',
  MAIN_BUYER: 'main_buyer_id',
  BRAND_IDS: 'brand_ids',
  BUYER_ID: 'buyer_id',
  AMAZON_MARKETPLACE_ENABLED: 'amazon_sync_marketplace_enabled',
} as const;
export type DealParticipantsField = ConstValues<typeof DealParticipantsField>;
